import React from "react";
import Popover from "@material-ui/core/Popover";
import PropTypes from "prop-types";

import DeleteConfirmation from "./DeleteConfirmation";

const PopoverDeleteConfirmation = ({
  anchorEl,
  onDelete,
  onClose,
  title,
  ...popoverProps
}) => (
  <Popover
    open={!!anchorEl}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{
      vertical: "center",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "center",
      horizontal: "left",
    }}
    {...popoverProps}
  >
    <DeleteConfirmation onDelete={onDelete} title={title} onCancel={onClose} />
  </Popover>
);

PopoverDeleteConfirmation.propTypes = {
  anchorEl: PropTypes.shape({}),
  title: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PopoverDeleteConfirmation;
